import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { obterStatusRequerimentosRequest } from '@store/requerimento/actions';
import { LoadingIndicator } from '@components';

import { PageBody } from './components/PageBody';

export const EmAndamento = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loading.show);

  useEffect(() => {
    dispatch(obterStatusRequerimentosRequest({ status: 'em andamento' }));
  }, [dispatch]);

  return isLoading ? <LoadingIndicator /> : <PageBody />;
};
